export class TurnoSemanal {
  lunes?: string[];
  martes?: string[];
  miercoles?: string[];
  jueves?: string[];
  viernes?: string[];
  sabado?: string[];
  domingo?: string[];

  constructor(turnos: any = {}) {
    this.lunes = turnos?.['lunes'] || null;
    this.martes = turnos?.['martes'] || null;
    this.miercoles = turnos?.['miercoles'] || null;
    this.jueves = turnos?.['jueves'] || null;
    this.viernes = turnos?.['viernes'] || null;
    this.sabado = turnos?.['sabado'] || null;
    this.domingo = turnos?.['domingo'] || null;
  }

  getDias() {
    const diasSemana = [
      'lunes',
      'martes',
      'miercoles',
      'jueves',
      'viernes',
      'sabado',
      'domingo',
    ];
    return diasSemana.filter(dia => this[dia] !== null);
  }

  getTurnosByDia(dia: string) {
    return this[dia];
  }
}
